<template>
  <div class="web-design-container">
    <div class="header-section">
      <h1>{{ webDesign.title }}</h1>
      <p class="subtitle">{{ webDesign.subtitle }}</p>
    </div>
    
    <div class="projects-grid">
      <div class="column">
        <a
          v-for="project in oddProjects"
          :key="project.id"
          class="project-card"
          :href="project.link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div class="project-gallery">
            <img :src="project.image" :alt="project.alt">
          </div>
          <div class="project-info">
            <h3>{{ project.title }}</h3>
            <p>{{ project.description }}</p>
            <div class="tech-stack">
              <span v-for="tech in project.techStack" :key="tech">{{ tech }}</span>
            </div>
            <div class="project-details">
              <div class="detail-item">
                <span class="label">Category:</span>
                <span class="value">{{ project.category }}</span>
              </div>
              <div class="detail-item">
                <span class="label">Year:</span>
                <span class="value">{{ project.year }}</span>
              </div>
            </div>
          </div>
        </a>
      </div>
      <div class="column">
        <a
          v-for="project in evenProjects"
          :key="project.id"
          :href="project.link"
          class="project-card"
          target="_blank"
        >
          <div class="project-gallery">
            <img :src="project.image" :alt="project.alt" />
          </div>
          <div class="project-info">
            <h3>{{ project.title }}</h3>
            <p>{{ project.description }}</p>
            <div class="tech-stack">
              <span v-for="tech in project.techStack" :key="tech">{{ tech }}</span>
            </div>
            <div class="project-details">
              <div class="detail-item">
                <span class="label">Category:</span>
                <span class="value">{{ project.category }}</span>
              </div>
              <div class="detail-item">
                <span class="label">Year:</span>
                <span class="value">{{ project.year }}</span>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
  <HomeButton />
</template>

<script>
import $ from 'jquery'
import 'magnific-popup/dist/jquery.magnific-popup.js'
import 'magnific-popup/dist/magnific-popup.css'
import '@fortawesome/fontawesome-free/css/all.css'
import HomeButton from '@/components/common/HomeButton.vue'

export default {
  name: 'WebDesign',
  components: {
    HomeButton
  },
  data() {
    return {
      webDesign: {
        title: "Web Design",
        subtitle: "Designing impactful and user-friendly websites",
        projects: [
                  {
            id: 1,
            image: require('@/assets/img/web/recruit.png'),
            alt: "Recruit Website",
            title: "Recruit Website",
            description: "A dynamic corporate recruitment website for TKP Corporation, built to showcase career opportunities, workplace culture, and employee stories for job seekers.",
            techStack: ["vue", "HTML5", "CSS3", "JavaScript"],
            link: "https://www.tkp.jp/recruit/",
            category: "Business Venue Website",
            year: "2025"
          },
          {
            id: 2,
            image: require('@/assets/img/web/cirq.png'),
            alt: "CIRQ Website",
            title: "CIRQ Website",
            description: "An elegant and luxurious business venue website offering wedding halls and event spaces for conferences, parties, and business gatherings across Japan. Features a premium design that showcases 62 facilities nationwide with comprehensive venue information and booking services.",
            techStack: ["WordPress", "HTML5", "CSS3", "JavaScript"],
            link: "https://www.cirq-hall.jp/",
            category: "Business Venue Website",
            year: "2025"
          },
          {
            id: 3,  
            image: require('@/assets/img/web/20th.png'),
            alt: "20th Website",
            title: "20th Website",
            description: "A 20th anniversary website that presents the company’s achievements in a clear and engaging way, using numbers to help customers understand its journey and success.",
            techStack: ["HTML", "CSS3", "JavaScript"],
            link: "https://www.tkp.jp/20th/",
            category: "Anniversary Website",
            year: "2025"
          },
          {
            id: 4,
            image: require('@/assets/img/web/onuma.png'),
            alt: "Onuma’s Personal Website",
            title: "Onuma’s Personal Website",
            description: "Designed and developed a portfolio website for Tokyo artist Onuma Kumiko, showcasing her skull-themed acrylic paintings and artistic journey. The site uses a clean, gallery-focused layout and expressive typography to reflect her vibrant pop-art style.",
            techStack: ["WordPress","HTML", "CSS3", "JavaScript"],
            link: "https://onuma-kumiko.net/",
            category: "Personal Website",
            year: "2023"
          },
          {
            id: 5,  
            image: require('@/assets/img/web/jongno.jpg'),
            alt: "Jongno Website",
            title: "Jongno Website",
            description: "An official website that highlights Jongno’s key products and achievements with a clean and concise layout.",
            techStack: ["WordPress", "HTML5", "CSS3", "JavaScript"],
            link: "https://korea-town.jp/",
            category: "Official Website",
            year: "2022"
          },
          {
            id: 6,  
            image: require('@/assets/img/web/rakuten.png'),
            alt: "Jongno Rakuten Website",
            title: "Jongno Rakuten Website",
            description: "A visually engaging e-commerce site on Rakuten, designed to showcase Jongno’s featured products and strong brand identity.",
            techStack: ["HTML5", "CSS3", "JavaScript"],
            link: "https://www.rakuten.ne.jp/gold/jongno-cheesehatogu/",
            category: "E-commerce",
            year: "2023"
          },
          {
            id: 7,
            image: require('@/assets/img/web/com.png'),
            alt: "Tkp communications Website",
            title: "Tkp communications Website",
            description: "A modern corporate site for TKP Communications, featuring a responsive layout and user-centered content structure.",
            techStack: ["HTML5", "CSS3", "JavaScript"],
            link: "https://tkpcom.jp/",
            category: "Official Website",
            year: "2024"
          },
          {
            id: 8,
            image: require('@/assets/img/web/translation.png'),
            alt: "Translation Service Website",
            title: "Translation Service Website",
            description: "A focused landing page introducing the company’s professional translation services with a clean, minimal design.",
            techStack: ["HTML5", "CSS3"],
            link: "https://journal-digitallife.com/translation/",
            category: "Information",
            year: "2022"
          },
          {
            id: 9,    
            image: require('@/assets/img/web/abroad.png'),
            alt: "Abroad Service Website",
            title: "Abroad Service Website",
            description: "A streamlined landing page introducing the company's study abroad and international support services.",
            techStack: ["HTML5", "CSS3"],
            link: "https://journal-digitallife.com/study-abroad/",
            category: "Information",
            year: "2022"
          }
        ]
      }
    }
  },
  computed: {
    sortedProjects() {
      return [...this.webDesign.projects].sort((a, b) => a.id - b.id);
    },
    oddProjects() {
      return this.sortedProjects.filter(project => project.id % 2 === 1);
    },
    evenProjects() {
      return this.sortedProjects.filter(project => project.id % 2 === 0);
    }
  },
  mounted() {
    this.$nextTick(() => {
      $('.image-popup').magnificPopup({
        type: 'image',
        closeOnContentClick: true,
        closeBtnInside: false,
        fixedContentPos: true,
        mainClass: 'mfp-no-margins mfp-with-zoom',
        image: {
          verticalFit: true
        },
        zoom: {
          enabled: true,
          duration: 300
        },
        callbacks: {
          open: function() {
            history.pushState({ popup: true }, '');
          },
          close: function() {
            if (history.state && history.state.popup) {
              history.back();
            }
          }
        }
      });

      window.addEventListener('popstate', this.handlePopState);
    });
  },
  beforeUnmount() {
    window.removeEventListener('popstate', this.handlePopState);
  },
  methods: {
    openPopup(imageUrl) {
      const $link = $('.image-popup').first();
      $link.attr('href', imageUrl);
      $link.trigger('click');
    },
    handlePopState() {
      if ($.magnificPopup.instance.isOpen) {
        $.magnificPopup.close();
      }
    }
  }
}
</script>

<style scoped>
.web-design-container {
  padding: 2rem 1rem;
  max-width: 1200px;
  margin: 0 auto;
}

.header-section {
  text-align: center;
  margin-bottom: 2rem;
}

.header-section h1 {
  font-size: 2.5rem;
  color: #fff;
  margin-bottom: 1rem;
}

.subtitle {
  font-size: 1.1rem;
  color: #666;
}

.projects-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  padding: 0.5rem;
}

@media (max-width: 992px) {
  .header-section h1 {
    font-size: 2.2rem;
  }
  
  .subtitle {
    font-size: 1rem;
  }
}

@media (max-width: 768px) {
  .projects-grid {
    grid-template-columns: 1fr;
    padding: 0;
  }
  
  .header-section {
    margin-bottom: 1.5rem;
  }
  
  .header-section h1 {
    font-size: 2rem;
  }
}

@media (max-width: 576px) {
  .header-section h1 {
    font-size: 1.8rem;
  }
  
  .subtitle {
    font-size: 0.9rem;
  }
  
  .project-info h3 {
    font-size: 1.2rem;
  }
  
  .project-info p {
    font-size: 0.9rem;
    line-height: 1.4;
  }
  
  .tech-stack span {
    font-size: 0.8rem;
    padding: 0.2rem 0.6rem;
  }
  
  .label {
    font-size: 0.8rem;
  }
  
  .value {
    font-size: 0.9rem;
  }
}

.project-card {
  break-inside: avoid;
  margin-bottom: 1.5rem;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  width: 100%;
  display: block;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
}

.project-card:hover {
  transform: translateY(-5px);
}

.project-gallery {
  position: relative;
  overflow: hidden;
}

.project-gallery img {
  width: 100%;
  height: auto;
  display: block;
  transition: transform 0.3s ease;
  aspect-ratio: 16/9;
  object-fit: cover;
}

.project-info {
  padding: 1.5rem;
}

.project-info h3 {
  color: #333;
  margin-bottom: 0.5rem;
}

.project-info p {
  color: #666;
  margin-bottom: 1rem;
}

.tech-stack {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.tech-stack span {
  background: #f0f0f0;
  padding: 0.3rem 0.8rem;
  border-radius: 15px;
  font-size: 0.9rem;
  color: #555;
}

.project-details {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #eee;
}

.detail-item {
  display: flex;
  flex-direction: column;
}

.label {
  font-size: 0.9rem;
  color: #666;
}

.value {
  font-weight: 500;
  color: #333;
}

.image-popup {
  display: block;
  cursor: pointer;
}

/* 触摸设备优化 */
@media (hover: none) {
  .gallery-overlay {
    opacity: 1;
    background: rgba(0, 0, 0, 0.3);
  }
  
  .project-card:active {
    transform: translateY(-5px);
  }
}
</style> 